import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-plan-info-popup',
  templateUrl: './plan-info-popup.component.html',
  styleUrls: ['./plan-info-popup.component.scss']
})
export class PlanInfoPopupComponent implements OnInit {
  planDescription:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
    console.log(this.data);
    if(this.data){
      this.planDescription = this.data['itemData'];
    }
  }

}
